import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';

import { ACTION_TYPES } from 'src/app/shared/utils/constants';
import { getCachedSettings, selectSettings } from 'src/app/stores/settings';
import * as settingsActions from 'src/app/stores/settings/settings.actions';

import { DEFAULT_SETTINGS } from '../appconfig/default-settings';
import { SettingsWsData, TSettings } from '../appconfig/settings.model';
import { FRODO_SOCKET_EVENTS, FrodoService } from '../frodo';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private cachedSettings = undefined;
  private settingsData: BehaviorSubject<Partial<TSettings>> = new BehaviorSubject<
    Partial<TSettings>
  >(DEFAULT_SETTINGS as TSettings);

  get getSettings() {
    return this.store.select(selectSettings);
  }

  set setSettings(settings: Partial<TSettings>) {
    this.settingsData.next(settings);
  }

  constructor(private store: Store, private frodoService: FrodoService) {
    this.frodoService.listen(FRODO_SOCKET_EVENTS.SETTINGS_UPDATED, (data: SettingsWsData) => {
      this.updateSettings(data);
      const settings = this.parseSettingsResponse(data);
      this.store.dispatch(settingsActions.updateSettings({ settings }));
    });

    this.cachedSettings = getCachedSettings();
    this.updateSettings(this.cachedSettings);
  }

  public updateSettings(settings: Partial<TSettings> | SettingsWsData) {
    const incomingSettings = this.parseSettingsResponse(settings);
    if (typeof incomingSettings === 'object' && Object.keys(incomingSettings).length) {
      this.setSettings = incomingSettings;
      localStorage.setItem('settings', JSON.stringify(incomingSettings));
    }
  }

  private parseSettingsResponse(settings: any): Partial<TSettings> {
    if (settings && settings.msg) return settings.msg;
    return settings;
  }

  public getTimeoutPerAction(action: ACTION_TYPES): number {
    switch (action) {
      case ACTION_TYPES.PICKUP: {
        return this.settingsData.getValue().order.timeouts.dispensing;
      }
      default: {
        return 0;
      }
    }
  }
}
